module.exports = __webpack_public_path__ + "static/media/unsplash-integration.ea018709.png";